import { replacePathParams } from '../http/replacePathParams';

import {
  type GetFollowersResponse,
  type GetFollowingResponse,
} from './aliases';

import {
  FOLLOWING_RELATIONSHIP_ENDPOINT,
  DELETE_FOLLOWING_ENDPOINT,
  FOLLOWERS_ENDPOINT,
  FOLLOWING_ENDPOINT,
  UPDATE_FOLLOWING_ENDPOINT,
} from '@/constants/endpoints.ts';
import { FollowRole } from '@/modules/follows/types.ts';
import { typedHttp } from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types.ts';

// The internal followsapi defaults to 100 and this is also the minimum, see apiary doc
export const FOLLOWS_LIMIT = 100;

export function fetchFollowingRelationship(userId: number) {
  return typedHttp.get(
    replacePathParams(FOLLOWING_RELATIONSHIP_ENDPOINT, {
      userId: String(userId),
    }),
    {
      withAuth: true,
    }
  );
}

export function addFollowing({
  sellerId,
}: {
  sellerId: number;
}): Promise<AxiosCompatibleResponse<void>> {
  return typedHttp.put(UPDATE_FOLLOWING_ENDPOINT, null, {
    withAuth: true,
    params: {
      user_id: String(sellerId),
    },
  });
}

export function deleteFollowing({ sellerId }: { sellerId: number }) {
  return typedHttp.delete(
    replacePathParams(DELETE_FOLLOWING_ENDPOINT, {
      userIdToUnfollow: String(sellerId),
    }),
    { withAuth: true }
  );
}

export function fetchFollows({
  role,
  sellerId,
  offset,
}: {
  role: FollowRole.Followers;
  sellerId: number;
  offset?: string;
}): Promise<AxiosCompatibleResponse<GetFollowersResponse>>;
export function fetchFollows({
  role,
  sellerId,
  offset,
}: {
  role: FollowRole.Following;
  sellerId: number;
  offset?: string;
}): Promise<AxiosCompatibleResponse<GetFollowingResponse>>;
export function fetchFollows({
  role,
  sellerId,
  offset,
}: {
  role: FollowRole;
  sellerId: number;
  offset?: string;
}) {
  const endpoint =
    role === FollowRole.Followers
      ? replacePathParams(FOLLOWERS_ENDPOINT, { userId: sellerId.toString() })
      : replacePathParams(FOLLOWING_ENDPOINT, { userId: sellerId.toString() });

  return typedHttp.get(endpoint, {
    params: {
      offset,
      limit: FOLLOWS_LIMIT,
    },
    withAuth: true,
  });
}
